import { useEffect, useState } from "react";
import API from "../services/api";

export default function Attendance() {

    const today = new Date()
        .toISOString()
        .split("T")[0];

    const [date, setDate] = useState(today);

    const [className, setClassName] = useState("");

    const [section, setSection] = useState("A");

    const [students, setStudents] = useState([]);

    const [attendanceData, setAttendanceData] = useState({});

    /* =========================
       LOAD STUDENTS
    ========================= */

    const loadStudents = async () => {

        if (!className || !section) {

            alert(
                "Please select class and section"
            );

            return;
        }

        try {

            const res = await API.get(
                `/students/by-class-section?className=${className}&section=${section}`
            );

            setStudents(res.data);

            /* Default all present */
            const defaultAttendance = {};

            res.data.forEach((student) => {

                defaultAttendance[student.id] = "Present";
            });

            setAttendanceData(defaultAttendance);

        } catch (err) {

            alert("Unable to load students");
        }
    };

    /* =========================
       TOGGLE ATTENDANCE
    ========================= */

    const toggleAttendance = (studentId) => {

        setAttendanceData({

            ...attendanceData,

            [studentId]:

                attendanceData[studentId]
                    === "Present"

                    ? "Absent"

                    : "Present"
        });
    };

    /* =========================
       MARK ALL PRESENT
    ========================= */

    const markAllPresent = () => {

        const updated = {};

        students.forEach((student) => {

            updated[student.id] = "Present";
        });

        setAttendanceData(updated);
    };

    /* =========================
       MARK ALL ABSENT
    ========================= */

    const markAllAbsent = () => {

        const updated = {};

        students.forEach((student) => {

            updated[student.id] = "Absent";
        });

        setAttendanceData(updated);
    };

    /* =========================
       SAVE ATTENDANCE
    ========================= */

    const saveAttendance = async () => {

        try {

            for (const student of students) {

                await API.post(
                    "/attendance/mark",
                    {
                        student_id: student.id,
                        date,
                        status:
                            attendanceData[student.id]
                    }
                );
            }

            alert(
                "Attendance saved successfully"
            );

        } catch (err) {

            alert(
                "Unable to save attendance"
            );
        }
    };

    return (

        <div className="p-6 bg-gradient-to-br from-gray-100 to-blue-50 min-h-screen">

            {/* HEADER */}
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6 lg:mb-8">

                <div>

                    <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800">
                        Attendance Management
                    </h1>

                    <p className="text-gray-500 mt-2">
                        Smart ERP Attendance System
                    </p>

                </div>

                <div className="bg-white rounded-3xl shadow-xl px-5 sm:px-8 py-4 sm:py-5 w-full sm:w-auto">

                    <p className="text-gray-500 text-sm">
                        Students Loaded
                    </p>

                    <h2 className="text-3xl sm:text-4xl font-bold text-blue-700">
                        {students.length}
                    </h2>

                </div>

            </div>

            {/* FILTER PANEL */}
            <div className="bg-white rounded-3xl shadow-2xl p-4 sm:p-6 lg:p-8 mb-6 lg:mb-8">

                <h2 className="text-xl sm:text-2xl font-bold mb-5 sm:mb-6">
                    Select Class & Section
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-5">

                    {/* DATE */}
                    <div>

                        <label className="block mb-2 font-semibold">
                            Attendance Date
                        </label>

                        <input
                            type="date"
                            value={date}
                            onChange={(e) =>
                                setDate(e.target.value)
                            }
                            className="border rounded-2xl p-4 w-full"
                        />

                    </div>

                    {/* CLASS */}
                    <div>

                        <label className="block mb-2 font-semibold">
                            Class
                        </label>

                        <select
                            value={className}
                            onChange={(e) =>
                                setClassName(e.target.value)
                            }
                            className="border rounded-2xl p-4 w-full"
                        >

                            <option value="">
                                Select Class
                            </option>

                            {[
                                "PP1",
                                "PP2",
                                "LKG",
                                "UKG",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12"
                            ].map((cls) => (

                                <option
                                    key={cls}
                                    value={cls}
                                >
                                    {cls}
                                </option>
                            ))}

                        </select>

                    </div>

                    {/* SECTION */}
                    <div>

                        <label className="block mb-2 font-semibold">
                            Section
                        </label>

                        <select
                            value={section}
                            onChange={(e) =>
                                setSection(e.target.value)
                            }
                            className="border rounded-2xl p-4 w-full"
                        >

                            <option value="">
                                Select Section
                            </option>

                            {"ABCDEFGHIJKLMNOPQRSTUVWXYZ"
                                .split("")
                                .map((letter) => (

                                    <option
                                        key={letter}
                                        value={letter}
                                    >
                                        {letter}
                                    </option>
                                ))}

                        </select>

                    </div>

                    {/* LOAD BUTTON */}
                    <div className="flex items-end">

                        <button
                            onClick={loadStudents}
                            className="bg-blue-700 hover:bg-blue-800 text-white w-full py-4 rounded-2xl font-bold"
                        >
                            Load Students
                        </button>

                    </div>

                </div>

            </div>

            {/* ATTENDANCE TABLE */}
            {students.length > 0 && (

                <div className="bg-white rounded-3xl shadow-2xl p-4 sm:p-6 lg:p-8">

                    {/* ACTION BAR */}
                    <div className="flex flex-col md:flex-row justify-between gap-4 mb-8">

                        <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold">
                            Attendance Sheet
                        </h2>

                        <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">

                            <button
                                onClick={markAllPresent}
                                className="bg-green-100 text-green-700 px-5 py-3 rounded-2xl font-bold w-full sm:w-auto"
                            >
                                Mark All Present
                            </button>

                            <button
                                onClick={markAllAbsent}
                                className="bg-red-100 text-red-700 px-5 py-3 rounded-2xl font-bold w-full sm:w-auto"
                            >
                                Mark All Absent
                            </button>

                        </div>

                    </div>

                    {/* TABLE */}
                    <div className="hidden md:block overflow-x-auto">

                        <table className="w-full">

                            <thead>

                                <tr className="bg-blue-50">

                                    <th className="p-5 text-left">
                                        Admission No
                                    </th>

                                    <th className="p-5 text-left">
                                        Student Name
                                    </th>
                                    <th className="p-5 text-left">
                                        Class
                                    </th>

                                    <th className="p-5 text-left">
                                        Attendance
                                    </th>

                                </tr>

                            </thead>

                            <tbody>

                                {students.map((student) => (

                                    <tr
                                        key={student.id}
                                        className="border-b hover:bg-gray-50"
                                    >

                                        <td className="p-5 font-bold text-blue-700">
                                            {student.admission_no}
                                        </td>

                                        <td className="p-5">
                                            {student.name}
                                        </td>

                                        <td className="p-5">
                                            {student.class} - {student.section}
                                        </td>

                                        <td className="p-5">

                                            <button
                                                onClick={() =>
                                                    toggleAttendance(student.id)
                                                }
                                                className={`px-5 py-2 rounded-2xl font-bold transition ${attendanceData[student.id]
                                                        === "Present"

                                                        ? "bg-green-100 text-green-700"

                                                        : "bg-red-100 text-red-700"
                                                    }`}
                                            >

                                                {
                                                    attendanceData[student.id]
                                                }

                                            </button>

                                        </td>

                                    </tr>

                                ))}

                            </tbody>

                        </table>

                    </div>

                    {/* MOBILE ATTENDANCE CARDS */}
                    <div className="md:hidden space-y-4">

                        {students.map((student) => {

                            const isPresent =
                                attendanceData[student.id] === "Present";

                            return (
                                <div
                                    key={student.id}
                                    className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4"
                                >

                                    {/* STUDENT INFO */}
                                    <div className="flex justify-between items-start gap-3 mb-4">

                                        <div className="min-w-0">

                                            <p className="text-xs font-semibold text-gray-500 uppercase">
                                                Admission No
                                            </p>

                                            <p className="text-base font-bold text-blue-700">
                                                {student.admission_no}
                                            </p>

                                        </div>

                                        <div
                                            className={`px-3 py-1 rounded-full text-xs font-bold ${isPresent
                                                    ? "bg-green-100 text-green-700"
                                                    : "bg-red-100 text-red-700"
                                                }`}
                                        >
                                            {isPresent ? "PRESENT" : "ABSENT"}
                                        </div>

                                    </div>


                                    {/* NAME */}
                                    <div className="mb-4">

                                        <p className="text-xs font-semibold text-gray-500 uppercase">
                                            Student
                                        </p>

                                        <p className="text-lg font-bold text-gray-800 break-words">
                                            {student.name}
                                        </p>

                                    </div>


                                    {/* CLASS */}
                                    <div className="mb-4">

                                        <p className="text-xs font-semibold text-gray-500 uppercase">
                                            Class
                                        </p>

                                        <p className="text-base font-semibold text-gray-700">
                                            {student.class} - Section {student.section}
                                        </p>

                                    </div>


                                    {/* ATTENDANCE BUTTON */}
                                    <button
                                        type="button"
                                        onClick={() => toggleAttendance(student.id)}
                                        className={`w-full py-4 rounded-2xl font-bold text-base transition active:scale-[0.98] ${isPresent
                                                ? "bg-green-600 text-white"
                                                : "bg-red-600 text-white"
                                            }`}
                                    >
                                        {isPresent
                                            ? "✓ PRESENT — Tap for Absent"
                                            : "✕ ABSENT — Tap for Present"}
                                    </button>

                                </div>
                            );
                        })}

                    </div>

                    {/* SAVE BUTTON */}
                    <button
                        onClick={saveAttendance}
                        className="mt-6 lg:mt-8 bg-blue-700 hover:bg-blue-800 text-white w-full sm:w-auto px-8 py-4 rounded-2xl font-bold text-base sm:text-lg"
                    >
                        Save Attendance
                    </button>

                </div>
            )}

        </div>
    );
}